import React from 'react';
import cn from 'clsx';

import LaptopSolidIcon from '../../shared/icons/laptop-solid-icon';
import StarSolidIcon from '../../shared/icons/star-solid-icon';
import Flag from '../flag/flag';

import { isWebOnlyProduct } from '../../shared/utils/product/product';

import { Maybe, ProductData } from '../../shared/types/graphql-types';

import styles from './product-secondary-flags.scss';

type Position = 'top' | 'bottom';

interface ProductSecondaryFlagsProps {
  hideLabel?: boolean;
  hideWebOnly?: boolean;
  position?: Position;
  product?: Maybe<ProductData>;
}

function ProductSecondaryFlags(props: ProductSecondaryFlagsProps) {
  const {
    hideLabel,
    hideWebOnly = false,
    position = 'bottom',
    product
  } = props;
  const isFleetPreferred =
    product?.isFleetPreferred || product?.rearProduct?.isFleetPreferred;
  const isWebOnly = isWebOnlyProduct(product);
  const labelOnlyFlag = hideLabel ? 'label-only-flag' : '';

  function getAllFlags() {
    const flags: JSX.Element[] = [];

    if (isFleetPreferred) {
      flags.push(
        <Flag
          className={cn(
            styles['flag'],
            styles['preferred-flag'],
            styles[position],
            styles[labelOnlyFlag]
          )}
          key="preferred-flag"
          renderIcon={
            <StarSolidIcon
              className={styles['flag-icon']}
              data-testid="preferred-flag-icon"
            />
          }
        >
          {!hideLabel ? ' Fleet Preferred' : ''}
        </Flag>
      );
    }

    if (isWebOnly && !hideWebOnly) {
      flags.push(
        <Flag
          className={cn(
            styles['flag'],
            styles['online-only-flag'],
            styles[position],
            styles[labelOnlyFlag]
          )}
          data-testid="web-only-flag"
          key="web-only-flag"
          renderIcon={
            <LaptopSolidIcon
              className={styles['flag-icon']}
              data-testid="web-only-flag-icon"
            />
          }
        >
          {!hideLabel ? ' ONLINE ONLY' : ''}
        </Flag>
      );
    }
    return flags;
  }

  return (
    <div
      className={cn(
        styles['container'],
        styles[position],
        'product-secondary-flags'
      )}
      data-testid="product-secondary-flags"
    >
      {getAllFlags()}
    </div>
  );
}

export default ProductSecondaryFlags;
